import { Video } from './VideoPlayer.styled';

interface VideoPlayerProps {
  captions: string | null;
  poster?: string;
  src: string;
}

export const VideoPlayer = ({ captions, poster, src }: VideoPlayerProps) => {
  const captionsProps = {
    ...(captions ? { src: captions, srcLang: 'en' } : {}),
  };

  return (
    <div className="video-player">
      <figure>
        <Video
          controls
          disablePictureInPicture
          poster={poster + '?height=309'}
          preload="metadata"
          src={src}
        >
          <track default kind="captions" label="English" {...captionsProps} />
          Your browser does not support this video file.
        </Video>
        {captions ? <figcaption>{captions}</figcaption> : null}
      </figure>
    </div>
  );
};
